import React, { useState } from "react";
import { format, parse, isValid } from "date-fns";
import { CalendarIcon } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";

// Tap-anywhere date field. Uses the in-app calendar rather than the native
// mobile date input, which doesn't open reliably on Android browsers.
export default function DateField({ value, onChange, testid = "date-field", placeholder = "Pick a date" }) {
  const [open, setOpen] = useState(false);
  const selected = value ? parse(value, "yyyy-MM-dd", new Date()) : undefined;
  const valid = selected && isValid(selected);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid}
          className="w-full h-11 bg-black/50 border border-white/15 px-3 flex items-center justify-between text-sm text-left outline-none focus:border-[#E2E30A] transition-colors">
          <span className={valid ? "text-white" : "text-zinc-500"}>
            {valid ? format(selected, "EEE d MMM yyyy") : placeholder}
          </span>
          <CalendarIcon className="h-4 w-4 text-[#E2E30A] shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-auto p-0 bg-[#141414] border-white/15">
        <Calendar
          mode="single"
          selected={valid ? selected : undefined}
          defaultMonth={valid ? selected : new Date()}
          onSelect={(d) => {
            if (d) onChange(format(d, "yyyy-MM-dd"));
            setOpen(false);
          }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
